import { render, staticRenderFns } from "./PanelDashboard.vue?vue&type=template&id=32e99a03"
import script from "./PanelDashboard.vue?vue&type=script&lang=ts"
export * from "./PanelDashboard.vue?vue&type=script&lang=ts"
import style0 from "./PanelDashboard.vue?vue&type=style&index=0&id=32e99a03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports